var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2408 22.75H8.7608C6.8708 22.75 5.4908 21.96 4.9608 20.6C4.4108 19.18 4.9208 17.42 6.2408 16.23L10.8808 12L6.2408 7.77C4.9208 6.58 4.4108 4.82 4.9608 3.4C5.4908 2.03 6.8708 1.25 8.7608 1.25H15.2408C17.1308 1.25 18.5108 2.04 19.0408 3.4C19.5908 4.82 19.0808 6.58 17.7608 7.77L13.1208 12L17.7708 16.23C19.0808 17.42 19.6008 19.18 19.0508 20.6C18.5108 21.96 17.1308 22.75 15.2408 22.75ZM12.0008 13.01L7.2508 17.33C6.4108 18.1 6.0408 19.22 6.3608 20.05C6.6608 20.82 7.5108 21.25 8.7608 21.25H15.2408C16.4908 21.25 17.3408 20.83 17.6408 20.05C17.9608 19.22 17.6008 18.1 16.7508 17.33L12.0008 13.01ZM8.7608 2.75C7.5108 2.75 6.6608 3.17 6.3608 3.95C6.0408 4.78 6.4008 5.9 7.2508 6.67L12.0008 10.99L16.7508 6.67C17.5908 5.9 17.9608 4.78 17.6408 3.95C17.3408 3.18 16.4908 2.75 15.2408 2.75H8.7608Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.681f92622675c2248bffbe664db3a807.svg";
export { ForwardRef as ReactComponent };